import { fetchCaptcha } from '@/api/sign'
export default {
  data() {
    return {
      loading: false,
      reverseRegister: true, // 控制 注册弹框 显示隐藏（默认：显示）
      reverseSix: false // 控制 六位验证码组件 显示隐藏(默认：隐藏)
    }
  },
  methods: {
    // 获取验证码
    async getCaptcha(params) {
      this.loading = true
      await fetchCaptcha(params).finally(() => {
        this.loading = false
      })

      this.loading = false
      this.reverseRegister = false
      this.reverseSix = true
      this.$Message.success({
        content: '验证码发送成功'
      })
      if (this.dealCountDown) this.dealCountDown()
    }
  }
}
